var loadData = true;

/**
 * Ads
 **/
(function($){

    // Presta Ads
    if($('#ads').length){
        $this = $('#ads');
        $class = ".ads-" + primary_slug;
        var href = ads_url + " " + $class + " .uk-slideset";

        $this.load(href, function(data) {
            $this.find('.uk-slideset').bxSlider({
                slideWidth: 600,
                minSlides: 1,
                maxSlides: 1,
                pager: false,
                auto: false
            });
        });
    }

})(jQuery);